export default {
  headerFont: '"Chime Saans", sans-serif;',
  primaryFont: '"Chime Saans Text", sans-serif;',
};
